/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Private
 *
 * 2 = Professional
 */
export enum UsageTypes {
  Private = 1,
  Professional = 2,
}
